<template lang="pug">
  span.custom
    span.fake-radio(@click.prevent="$emit('input', modelValue)",:class="{'checked': modelValue === value}")
    input(type="radio",:id="uniqueId",:checked="modelValue === value",@change="$emit('input',modelValue)")
    label(:for="uniqueId")
      | &nbsp;
      slot
</template>

<script>
export default {
  name: 'CustomRadio',
  props: {
    value: {
      type: [String, Boolean],
      default: '',
    },
    modelValue: {
      type: [String, Boolean],
      default: '',
    },
  },
  computed: {
    uniqueId: function() {
      return `radio-button-${this._uid}`
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/custom';
label {
  display: inline;
}

input {
  display: none;
}

.fake-radio {
  display: inline-block;
  position: relative;
  top: 3px;
  width: 1.2rem;
  height: 1.2rem;
  border: 1px solid rgba(black, 0.3);
  border-radius: 50%;
}

.checked {
  border: 6px solid $primary;
  transition: border-color 0.1s;
}
</style>
